var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddPhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11 18V6H13V18H11Z",
    fill: "black",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M18 13H6V11H18V13Z",
    fill: "black",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M7.53953 1.94211C8.08774 1.69866 8.65962 1.49865 9.25074 1.3465L9.74926 3.28338C9.26641 3.40766 8.79924 3.57103 8.35126 3.76997L7.53953 1.94211ZM2.31546 6.77954C2.89318 5.70983 3.64259 4.74725 4.52656 3.92843L5.88568 5.39567C5.16132 6.06665 4.54775 6.85499 4.07522 7.72994L2.31546 6.77954ZM1 11.9999C1 11.3863 1.05034 10.7837 1.14732 10.1962L3.12062 10.5219C3.04134 11.0022 3 11.4958 3 11.9999C3 12.504 3.04134 12.9976 3.12062 13.4779L1.14732 13.8036C1.05034 13.2161 1 12.6135 1 11.9999ZM4.52655 20.0714C3.64259 19.2525 2.89318 18.29 2.31546 17.2203L4.07522 16.2699C4.54775 17.1448 5.16132 17.9331 5.88567 18.6041L4.52655 20.0714ZM9.25074 22.6533C8.65962 22.5012 8.08774 22.3011 7.53953 22.0577L8.35125 20.2298C8.79924 20.4288 9.26641 20.5921 9.74926 20.7164L9.25074 22.6533Z",
    fill: "black",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M21 12C21 7.02944 16.9706 3 12 3V1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23V21C16.9706 21 21 16.9706 21 12Z",
    fill: "black",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPhoto);
export default __webpack_public_path__ + "static/media/addPhoto.c6cacc40f573e8ec9b0a2881f2e72bfd.svg";
export { ForwardRef as ReactComponent };